import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

// ng ngx
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NGXLogger } from "ngx-logger";
import { TranslateService } from "@ngx-translate/core";

// common
import { Dialog } from "app/common/dialog";
import { BaseModalComponent } from "../base-modal/base-modal.component";

// services
import { ConfigurationService } from "app/services/configuration/configuration.service";

// models
import { SocketReadyState } from "app/models/enums.model";
import { MachineInterface } from "app/models/machine.model";

// package.json
import packageJson from "../../../../../../../package.json";

@Component({
    selector: "app-configuration",
    templateUrl: "./configuration.component.html",
    styleUrls: ["./configuration.component.scss"],
    standalone: false
})
export class ConfigurationComponent
  extends BaseModalComponent
  implements OnInit
{
  /*
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3,
  */
  @Input() localSocketReadyState: SocketReadyState;
  @Input() machine: MachineInterface;

  public password: string = "";
  blockUser: boolean = false;

  public version: string = packageJson.version;

  public URL_API: string = "";
  public URL_WebSocketCloud: string = "";
  public ConfigurationPassword: string = "";

  public basicPwdShow = false;
  public basicPwdShow2 = false;

  public ok: boolean = false;
  public error: boolean = false;

  @ViewChild("focusInput") focusInput: ElementRef;

  constructor(
    public _translateService: TranslateService,
    protected dialog: Dialog,
    public title: Title,
    public logger: NGXLogger,
    public modalService: NgbModal,
    public configurationService: ConfigurationService
  ) {
    super(_translateService, dialog, title, logger, modalService);
    this.URL_API = this.configurationService.get_URL_API();
    this.URL_WebSocketCloud =
      this.configurationService.get_URL_WebSocketCloud();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  openModal(blockUser = false) {
    this.blockUser = blockUser;
    this.error = false;
    this.password = "";
    this.checkPass();
    super.openModal();
    setTimeout(() => {
      this.focusInput.nativeElement.focus();
    }, 1000);
    this.modalReference.result
      .then(() => {
        this.isModalOpen = false;
      })
      .catch((res) => {});
  }

  changeURL_API() {
    this.configurationService.set_URL_API(this.URL_API);
    window.location.reload();
  }

  changeURL_WebSocketCloud() {
    this.configurationService.set_URL_WebSocketCloud(this.URL_WebSocketCloud);
    window.location.reload();
  }

  changeConfigurationPassowrd() {
    try {
      this.configurationService.set_ConfigurationPassword(
        this.ConfigurationPassword
      );
      this.ConfigurationPassword = "";
    } catch (e) {}
  }

  checkPass() {
    this.error = false;
    const pass = this.configurationService.get_ConfigurationPassword();
    if (this.password && this.password == pass) {
      this.ok = true;
    } else {
      this.ok = false;
      this.error = this.password != "";
      // this.modalService.dismissAll();
    }
    this.password = "";
  }
}
